<template>
  <div class="ruKuZuoyeWarp app-containe">
    <div class="ruKuZuoyeWarp-body">
      <!-- 查询条件 -->
      <div ref="searchBox" class="formBox margbot">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="100px" size="mini">
          <div class="formItemBox ">
          <el-form-item label="预报编号:">
            <el-input v-model.trim="formData.shipForecastNo" placeholder="请输入预报编号" size="mini"
             ></el-input>
          </el-form-item>
          <el-form-item label="车船编号:">
            <el-input  v-model.trim="formData.plateNumber" placeholder="请输入车号" size="mini"
              ></el-input>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期:">
            <div style="display: flex;">
            <el-date-picker v-model="formData.startDate" size="mini" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd"></el-date-picker>
            -
            <el-date-picker v-model="formData.endDate" size="mini" placeholder="选择日期" type="date"
              value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </el-form-item>

          <el-form-item prop="completeStatus" label="预报状态:">
            <el-select v-model="formData.completeStatus" clearable placeholder="请选择" filterable size="mini"
              >
              <el-option v-for="(item, index) in completeStatusData" :key="index" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="arrivalMethod" label="到货方式:">
            <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
              <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="getDataList" btnCode="00cP004B001" v-if="btnFlg[0]">查询
            </el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP004B002" v-if="btnFlg[1]">重置
            </el-button>
            <el-button type="primary" size="mini" @click="xinzeng" btnCode="00cP004B003" v-if="btnFlg[2]">新增</el-button>
            <el-button type="primary" size="mini" @click="xiugai" btnCode="00cP004B004" v-if="btnFlg[3]">修改</el-button>
            <el-button type="primary" size="mini" @click="shanchu" btnCode="00cP004B005" v-if="btnFlg[4]">删除</el-button>
            <el-button type="primary" size="mini" @click="addRKPlan" btnCode="00cP004B006" v-if="btnFlg[5]">添加入库计划
            </el-button>
            <el-button type="primary" size="mini" @click="daochu" btnCode="00cP004B007" v-if="btnFlg[6]">导出</el-button>
            <el-button type="primary" size="mini" @click="daohuoWC" btnCode="00cP004B00C" v-if="btnFlg[11]">到货完成
            </el-button>
          </el-form-item>
          <el-form-item>
            <span>&nbsp;
              总吨数:
              <span style="color: red">{{ allPlanWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ allPlanPiece }}</span> &nbsp;件
            </span>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div :style="{ height: h }" v-loading='tabLoading'>
        <el-table height="100%" size="mini" border center bordersize="mini" ref="tableData" :data="tableData"
          style="width: 100%" class="tableComent" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          highlight-current-row @row-click="dianjixuanzhong"  >
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="lookShippingDetails(scope.row)" size="mini">明细</el-button>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="shipForecastNo" label="预报编号" align="center" width="220">
          </el-table-column>
          <el-table-column prop="forecastDate" label="日期" align="center" width="150" :formatter="dateFormat">
          </el-table-column>
          <el-table-column prop="arrivalMethod" label="到货方式" align="center" width="100"></el-table-column>
          <el-table-column prop="plateNumber" label="车船号" align="center" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
            width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220">
          </el-table-column>
          <el-table-column prop="completeStatus" label="预报状态" align="center" width="110">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.completeStatus == '0'">未完成</span>
                <span v-if="scope.row.completeStatus == '1'">已完成</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="planNumber" label="计划总件" align="center" width="110"></el-table-column>
          <el-table-column prop="planWeight" label="计划总吨" align="center" width="110"></el-table-column>
          <el-table-column prop="actualNumber" label="实入总件" align="center" width="110"></el-table-column>
          <el-table-column prop="actualWeight" label="实入重量(吨)" align="center" width="120"></el-table-column>
          <el-table-column prop="createUser" label="创建人" align="center" width="120"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="180" :formatter="dateTimeFormat">
          </el-table-column>
        </el-table>
      </div>
      <div class="pags" style="text-align: left">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
          :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- dialogs -->
    <!-- 新增船运预报 -->
    <addcy-dialog v-if="xzVisible" :xzVisible.sync="xzVisible" :title="xzTitle" :xztableData="xztableData"
      :shipForecastMasterId="shipForecastMasterId" :RKData.sync='RKData'></addcy-dialog>
    <!-- 添加入库计划 -->
    <add-plan v-if="addPlanVisible" :addPlanVisible.sync='addPlanVisible' :shipForecastMasterId="shipForecastMasterId">
    </add-plan>
  </div>
</template>

<script>
import {
  getMasterList, // 列表查询
  updateMasterForArrivalComplete, // 列表查询
  getWeightAndPiece, // 总吨数与总件数
  removeMaster // 删除
} from '@/api/wms-access'
import {
  getRelationCustomer
} from '@/api/wms-stock'
import {
  dateTimeFormat,
  dateFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import addcyDialog from './addcyDialog.vue'
import addPlan from './addRuKuPlan.vue'

export default {
  components: {
    addcyDialog,
    addPlan
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      dateFormat: dateFormat,
      formData: {
        customerTaxId: '',
        primaryCustomerTaxId: '',
        startDate: '', // 开始日期，//选填
        endDate: '', // 结束日期，//选填
        plateNumber: '', // 车船号，//选填
        shipForecastNo: '', // 预报编号
        completeStatus: '0', // 预报状态
        arrivalMethod: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageInfoXQ: {
        pageSize: 20,
        pageNo: 1
      },
      total: 0,
      RKData: [], //
      btnFlg: [],
      tableData: [],
      allPlanPiece: 0,
      allPlanWeight: 0,
      completeStatusData: [{
        value: '',
        label: '全部'
      },
      {
        value: '0',
        label: '未完成'
      },
      {
        value: '1',
        label: '已完成'
      }
      ],
      arrivalMethodData: [
        // {
        //   value: '1',
        //   label: '火运'
        // },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      btnIdArr: [
        '00cP004B001',
        '00cP004B002',
        '00cP004B003',
        '00cP004B004',
        '00cP004B005',
        '00cP004B006',
        '00cP004B007',
        '00cP004B008',
        '00cP004B009',
        '00cP004B00A',
        '00cP004B00B',
        '00cP004B00C'
      ],
      detailsH: '200px',
      h: '500px',
      xuanzhongArr: null,
      xcLoading: false,
      inWeighingMethod: '',
      xzVisible: false,
      xzTitle: '新增预报',
      xztableData: [],
      addPlanVisible: false,
      shipForecastMasterId: ''
    }
  },
  methods: {
    // 查看明细
    lookShippingDetails (row) {
      this.$router.push({
        path: '/shippingDetails',
        query: {
          shipForecastMasterId: row.shipForecastMasterId
        }
      })
    },
    // 总重量
    getWeightAndPieces () {
      getWeightAndPiece({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        startDate: this.formData.startDate,
        endDate: this.formData.endDate,
        plateNumber: this.formData.plateNumber, // 车船号
        shipForecastNo: this.formData.shipForecastNo, // 预报编号
        completeStatus: this.formData.completeStatus,
        arrivalMethod: this.formData.arrivalMethod
      })
        .then(res => {
          this.allPlanPiece = res.allPlanPiece
          this.allPlanWeight = res.allPlanWeight
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    xinzeng () {
      this.xzVisible = true
      this.xzTitle = '新增预报'
      // this.shipForecastMasterId = this.xuanzhongArr.shipForecastMasterId
    },
    xiugai () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
      } else {
        this.xzVisible = true
        this.xzTitle = '修改预报'
        this.shipForecastMasterId = String(this.xuanzhongArr.shipForecastMasterId)
      }
    },
    // 添加入库计划
    addRKPlan () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
      } else {
        this.addPlanVisible = true
        this.shipForecastMasterId = this.xuanzhongArr.shipForecastMasterId
      }
    },
    shanchu () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeMaster(this.xuanzhongArr.shipForecastMasterId)
          .then(res => {
            DonMessage.success('删除成功')
            that.getDataList()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    getDataList () {
      this.tabLoading = true
      getMasterList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        startDate: this.formData.startDate,
        endDate: this.formData.endDate,
        plateNumber: this.formData.plateNumber, // 车船号
        shipForecastNo: this.formData.shipForecastNo, // 预报编号
        completeStatus: this.formData.completeStatus,
        arrivalMethod: this.formData.arrivalMethod
      })
        .then(res => {
          this.tabLoading = false
          this.tableData = res.list
          this.total = res.total
          if (res.list.length > 0) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => {
              this.$refs.tableData.setCurrentRow(res.list[0])
            })
          } else {
            this.tableData = []
          }
          this.getWeightAndPieces()
        })
        .catch(error => {
          this.tabLoading = false
          DonMessage.error(error.message)
        })
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.startDate = ''
      this.formData.endDate = ''
      this.formData.plateNumber = ''
      this.formData.shipForecastNo = ''
      this.formData.completeStatus = '0'
      this.formData.arrivalMethod = ''
      this.pageInfo.pageNo = 1
      this.pageInfo.pageSize = 20
      this.getDataList()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getDataList()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getDataList()
    },
    // 点击到货完成
    daohuoWC () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
      } else {
        this.$confirm('是否确认完成?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            updateMasterForArrivalComplete({
              shipForecastMasterId: this.xuanzhongArr.shipForecastMasterId
            })
              .then((res) => {
                this.getDataList()
                loading.close()
              })
              .catch((err) => {
                loading.close()

                DonMessage.error(err.message)
              })
          })
          .catch(() => {})
      }
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/shipForecast/exportMasterAndSummary', {
          ...this.formData
        },
        '船运预报列表'
      )
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycChuanYun')
    this.getRelationCustomerS()
    this.getDataList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.getDataList()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  .ruKuZuoyeWarp {
    width: 100%;
    position: relative;
  }

  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
